// How a single chart was reached, carried as router navigation state rather than in the URL: it's
// context for how we got here, so a direct or shared link to the same chart implies neither.
export interface ChartRouteState {
  // Opened from a dashboard card's "Open in focused view" — the view offers a way back to it.
  fromDashboardId?: string;
  // The dashboard's search when the chart was opened, so going back keeps its filters and dates.
  fromDashboardSearch?: string;
  // Opened from the chart library — the view renders as a modal over the library (see ChartsPage).
  fromChartLibrary?: boolean;
}

// Router state is `unknown` (anything can push it), so keep only the fields that have the right type.
export const readChartRouteState = (state: unknown): ChartRouteState => {
  if (typeof state !== 'object' || state === null) return {};
  const fromDashboardId = 'fromDashboardId' in state ? state.fromDashboardId : undefined;
  const fromChartLibrary = 'fromChartLibrary' in state ? state.fromChartLibrary : undefined;
  const fromDashboardSearch =
    'fromDashboardSearch' in state ? state.fromDashboardSearch : undefined;
  return {
    ...(typeof fromDashboardId === 'string' ? { fromDashboardId } : {}),
    ...(typeof fromDashboardSearch === 'string' && fromDashboardSearch.startsWith('?')
      ? { fromDashboardSearch }
      : {}),
    ...(fromChartLibrary === true ? { fromChartLibrary } : {})
  };
};

export const chartLibraryPath = (company: string): string => `/${company}/charts`;

export const dashboardReturnPath = (company: string, dashboardId: string, search = ''): string =>
  `/${company}/dashboard/${dashboardId}${search}`;
